import React from "react";
import { crossIcon } from "../../asset";
import { useNavigate } from "react-router-dom";
interface props {
  children: React.ReactNode;
  className?: string;
  onClose: () => void;
  isCross?: boolean;
  width?: string;
}
export default function ModalLayout({
  children,
  className,
  onClose,
  isCross = true,
  width = "max-w-lg",
}: props) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };
  return (
    <div className="fixed w-full h-full left-0 top-0 z-50 flex items-center justify-center px-2 ">
      <div
        className="w-full h-full bg-black/40 absolute left-0 top-0 z-10 "
        onClick={handleClose}
      ></div>
      <div className={`relative z-50 min-w-[30vw] ${width} w-full `}>
        {isCross && (
          <div
            className="bg-white rounded-full w-10 h-10 items-center flex justify-center absolute bottom-[105%] right-0 cursor-pointer"
            onClick={handleClose}
          >
            <img src={crossIcon} alt="" className="w-6" />
          </div>
        )}
        <div className="min-h-max p-8 max-h-screen overflow-y-auto  bg-white rounded-lg overflow-hidden  ">
          {children}
        </div>
      </div>
    </div>
  );
}
